import withValidationHoc from './withValidationHoc';
import { Button } from '@atrocit/scl';

export default withValidationHoc(Button);